import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

// A capability granted to one *_MEMBERSHIP share (per-share grant). CapabilityUSID is chosen from the
// "Capability" picklist when granting; CapabilityName/ObjectType are LEFT-joined for display.
class MembershipCapabilityEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "MembershipCapability";
        this.defaultCacheSize = 1000;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", false, true, true, false, null, null, null, 36, null, null, "UUID", null, false,
        );
        this.attributes["MembershipUSID"] = new EnterpriseComponentAttributeMetadata(
            "MembershipUSID", false, false, true, false, null, null, null, null, null, null, "UUID", null, false,
        );
        this.attributes["CapabilityUSID"] = new EnterpriseComponentAttributeMetadata(
            "CapabilityUSID", false, false, true, false, "Capability", null, null, null, null, null, "UUID", null, false,
        );
        this.attributes["CapabilityName"] = new EnterpriseComponentAttributeMetadata(
            "CapabilityName", false, true, false, false, null, null, null, 100, null, null, "String", null, false,
        );
        this.attributes["CapabilityObjectType"] = new EnterpriseComponentAttributeMetadata(
            "CapabilityObjectType", false, true, false, false, null, null, null, 100, null, null, "String", null, false,
        );
        this.attributes["CreatedDatetime"] = new EnterpriseComponentAttributeMetadata(
            "CreatedDatetime", false, true, false, false, null, null, null, null, null, null, "Datetime", null, false,
        );
    }
}

export default MembershipCapabilityEnterpriseComponentMetadata;
